// extracted by mini-css-extract-plugin
module.exports = {"tick":"styles_tick__2rcio","green":"styles_green__Xx_yw","yellow":"styles_yellow__lsQ2F","red":"styles_red__DxHCa","gray":"styles_gray__fKOnS"};